import { useState } from "react";
import styles from "../../../../propertydetails.module.css";
import { Edit, Eye, EyeOff, Trash } from "react-feather";

const KeyFobCard = ({ item, setIsFormOpen, setEditFormData, setOpenDeleteModal, setDeletedId }) => {
    const [lockVisible, setLockVisible] = useState(false);

    return <>
        <div className={`${styles.KeyFobList}`}>
            <div className={`${styles.ListTopSec}`}>
                <p className={`${styles.ListTitle}`}>{item?.title}</p>
                <button onClick={(e) => { setIsFormOpen(true); setEditFormData(item); }}><Edit /></button>
                <button onClick={(e) => { setOpenDeleteModal(true); setDeletedId(item?.id); }}><Trash /></button>
                {lockVisible && <button onClick={(e) => setLockVisible(false)}><EyeOff /></button>}
                {!lockVisible && <button onClick={(e) => setLockVisible(true)}><Eye /></button>}
            </div>
            <div className={`${styles.ListBottomSec}`}>
                <span className={`${styles.ListNumber}`}>{lockVisible ? item?.card_number : "********"}</span>
            </div>
        </div>
    </>
}

export default KeyFobCard;